import {
	MenuItem as MenuItemMui,
} from '@mui/material';
import { ChildrenProps, appendClassName } from '@componentLibraryWrapper/common';
import './menuItem.scss';

export interface MenutItemProps extends ChildrenProps<HTMLLIElement> {
	selected?: boolean,
	value?: string | number | readonly string[]
}

const MenuItem = ({
	className,
	...rest
}: MenutItemProps) => {
	return (
		<MenuItemMui
			{...rest}
			className={appendClassName('sm-menuitem', className)}/>
	)
}

export default MenuItem;